// extracted by mini-css-extract-plugin
export default {"lineClam":"TrailItem_lineClam__DmG+U","lineClam1":"TrailItem_lineClam1__kP0xb"};